module.exports = __webpack_public_path__ + "static/media/headandneckcancer.b3a8947f.svg";